import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import { TableFilterProvider } from 'tableFilterContext';
import { Routes } from 'routes';
import { AppContext } from 'context';
import { UserRole } from 'types';
import BuyerList from './BuyerList';

const BuyerListPage: React.FC = () => {
  const { t } = useTranslation();

  const context = useContext(AppContext);

  const roles = context.getRoles?.();
  const sortingCenter = context.getSortingCenter?.();
  const allowedCreate =
    sortingCenter?.isActive && roles && (roles.includes(UserRole.ROLE_MANAGER) || context.hasLeastOneAdminRole());

  return (
    <PageContent
      title={t('buyers.referentialBuyers')}
      noPadding
      action="create"
      actionButtonLink={allowedCreate ? Routes.BuyersCreate : undefined}
    >
      <TableFilterProvider>
        <BuyerList />
      </TableFilterProvider>
    </PageContent>
  );
};
export default BuyerListPage;
